const INITIALS_LENGTH = 2;
const ALL_ALPHABETS_PATTERN = '\\p{L}';
const WHITESPACE_PATTERN = '\\s';

function getInitials(str: string): string {
    return str
        .toUpperCase()
        .split(' ')
        .map((part) => part.charAt(0))
        .join('');
}

function filterSpecialCharacters(text: string): string {
    const regex = new RegExp(`[^${ALL_ALPHABETS_PATTERN}${WHITESPACE_PATTERN}]`, 'gu');
    return text.replace(regex, '');
}

export function getNameInitials(
    str: string | undefined,
    initialsLength: number = INITIALS_LENGTH,
): string | undefined {
    if (!str) {
        return undefined;
    }

    const filteredText = filterSpecialCharacters(str);
    return getInitials(filteredText).slice(0, initialsLength) || undefined;
}
